import { CentralErrorHandlingProvider } from '@experiences/error';
import {
    ServiceOrderProvider,
    ToastNotification,
    UiDialogProvider,
    UiErrorBoundary,
} from '@experiences/ui-common';
import React from 'react';
import { Router } from 'react-router-dom';

import { PortalAuthenticationProvider } from '../auth/PortalAuthenticationProvider';
import { history } from '../History.default';
import Routes from './Routes';

export default function App() {
    return (
        <CentralErrorHandlingProvider>
            <ToastNotification>
                <Router history={history}>
                    <PortalAuthenticationProvider>
                        <UiDialogProvider>
                            <ServiceOrderProvider initialState={[]}>
                                <UiErrorBoundary>
                                    <Routes />
                                </UiErrorBoundary>
                            </ServiceOrderProvider>
                        </UiDialogProvider>
                    </PortalAuthenticationProvider>
                </Router>
            </ToastNotification>
        </CentralErrorHandlingProvider>
    );
}
